module.exports = __webpack_public_path__ + "media/common/images/cta/lori-f117a4bb06aaf0abc3e3d1dd12ea023f.jpeg";